import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "basic-layout" }
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = { class: "footer-content" }
const _hoisted_4 = { class: "footer-nav" }
const _hoisted_5 = ["href"]

import { useRouter } from "vue-router";

// 导航链接

export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {

const navLinks = [
  { name: "首页", href: "/" },
  { name: "关于我们", href: "/about" },
  { name: "服务项目", href: "/services" },
  { name: "联系我们", href: "/contact" },
  { name: "隐私政策", href: "/privacy" },
  { name: "使用条款", href: "/terms" },
];

// 路由实例
const router = useRouter();

// 导航至用户登录页面
const ToUserLoginPage = () => {
  router.push("/user-login");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { class: "header" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_router_link, { to: "/" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            class: "logo",
                            src: _imports_0,
                            alt: "logo"
                          }, null, -1),
                          _createElementVNode("div", { class: "title" }, "贡有质", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 12,
                  style: {"text-align":"right"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      class: "login-button",
                      type: "primary",
                      onClick: ToUserLoginPage
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("登录/注册 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, { class: "content" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_footer, { class: "footer" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
                  return _createElementVNode("a", {
                    key: link.name,
                    href: link.href,
                    class: "nav-link"
                  }, _toDisplayString(link.name), 9, _hoisted_5)
                }), 64))
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "footer-copyright" }, [
                _createElementVNode("p", null, "© 北京聚客帮科技发展有限公司 版权所有"),
                _createElementVNode("a", {
                  href: "http://beian.miit.gov.cn/",
                  target: "_blank"
                }, "备案号：京ICP备17063633号-4")
              ], -1))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})